/* @flow */

import { graphql, commitMutation } from 'react-relay/legacy';

import type { ModifyPortfolioItems } from './types';

export const ADD = 'ADD';
export const REMOVE = 'REMOVE';

const mutation = graphql`
    mutation ModifyPortfolioItemsMutation($input: ModifyPortfolioItemsInput!) {
        modifyPortfolioItems(input: $input) {
            portfolio {
                id
            }
        }
    }
`;

export function commit(
    environment: Object,
    {
        action,
        itemsIds,
        portfolioId,
        portfolioItemsIds,
        userId,
        onCompleted,
        onError,
    }: ModifyPortfolioItems
): void {
    let input = { action, portfolioId, userId };

    if (action === REMOVE) {
        input = { ...input, portfolioItemsIds };
    } else if (action === ADD) {
        input = { ...input, itemsIds };
    }

    commitMutation(environment, {
        mutation,
        variables: { input },
        onCompleted,
        onError,
    });
}

export default { commit };
